import React, { useRef } from "react";
import { useState,useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import WestIcon from "@mui/icons-material/West";
import CloseIcon from "@mui/icons-material/Close";
import { openPopup } from "../../stateManagement/actions/popupActions";
import { generateSkuDataForUnsellableReturn, QuantityObj, QuantityReason } from "./PrimaryReturnUtils";
import "./PrimaryReturn.css"
import "./PrimaryReturnWithoutGRNEdit.css"
import PrimaryReturnWithoutGRNBatchItem from "./PrimaryReturnWithoutGRNBatchItem";
import CustomAutocomplete from "../../components/dms_common/CustomAutocomplete";
import CustomCsPcInput from "../../components/dms_common/CustomCsPcInput";
import RenderSvg from "../../components/renderSvg/RenderSvg";
import { getBatchDetailsFromDbPrimaryReturn, setBatchDetailsInDbPrimaryReturn } from "../SalesReturn/SalesReturnService";
import { Loader } from "../../components/loader/Loader";

export interface withoutGRNBatchDetails{
    skuCode: string;
    skuName: string;
    batchId: string;
    caseToPieceQty: number;
    otherToPieceQty: number;
    initialUnsellableCaseQty: number;
    initialUnsellablePieceQty: number;
    initialUnsellableOtherQty: number;
    //User will edit these values and these values will actually be the returned quantities for the batch
    unsellableCaseQty: number;
    unsellablePieceQty: number;
    unsellableOtherQty: number;
    initialReasonQuantityMap?: Record<string, QuantityObj>;
    otherUnitName: string;
    reasonQuantityMap?: Record<string, QuantityObj>
    priceTodistributor: number;
    mrp: number;
}

export interface SkuDataForUnsellableReturn {
    skuCode: string;
    skuName: string;
    caseToPieceQty: number;
    otherToPieceQty: number;
    batchCode: string;
    batchIds: string[];
    otherUnitName: string;
    batchDetails?: withoutGRNBatchDetails[];
}

export interface CachedBatchDetails {
  batchDetails?: withoutGRNBatchDetails[];
}

const BatchEditorWithoutGRN: React.FC<{
    savedBatch: withoutGRNBatchDetails;
    batch: withoutGRNBatchDetails;
    onReset: (reason: string) => void;
    onSave: () => void;
    handleReasonQuantityChange: (batchId: string, reason: string, quantityObj: QuantityObj) => void;
    removeBatch: () => void;
    canRemoveFromReturn: boolean;
    batchDetails?: withoutGRNBatchDetails[];
    selectedSkuCode?: string;

}> = ({ savedBatch, batch, onReset, onSave, handleReasonQuantityChange, removeBatch, canRemoveFromReturn,  batchDetails, selectedSkuCode }) => {

  const ConfigDictionary = localStorage.getItem("ConfigDictionary") ? JSON.parse(localStorage.getItem("ConfigDictionary") || '{}') : {};

  const {caseUnitLabelPrimaryReturn, packUnitLabelPrimaryReturn, otherUnitLabelPrimaryReturn } = ConfigDictionary;

  //If the current value is different from the one in skuData, which is current saved value, then enable save button
  
  const presentInInitial = batchDetails?.find((b) => b.batchId === batch.batchId);



  const isDifferentFromInitial = presentInInitial ? JSON.stringify(presentInInitial.reasonQuantityMap) !== JSON.stringify(batch.reasonQuantityMap) : true;

  const isSaveDisabled = (savedBatch && (batch ? JSON.stringify(savedBatch.reasonQuantityMap) === JSON.stringify(batch.reasonQuantityMap) : true) && !isDifferentFromInitial);

  return (
    <div className="batch-editor-container-delivery">
      <div className="batch-editor-body-delivery">
        {Object.keys(batch?.reasonQuantityMap ?? {}).map((reasonKey) => {
          const quantityObj = batch?.reasonQuantityMap?.[reasonKey] || { caseQty: 0, pieceQty: 0, otherQty: 0 };
          return (
            <div key={reasonKey} className="reason-quantity-row-delivery">
              <span className="reason-text-delivery">{reasonKey}</span>
              <div style={{display: "flex", flexDirection: "column", alignItems: "flex-start"}}>
                <div className="quantity-inputs-delivery">
                  <CustomCsPcInput
                    value={quantityObj.caseQty}
                    onChange={(e) =>
                      handleReasonQuantityChange(batch.batchId, reasonKey, {
                        ...quantityObj,
                        caseQty: parseInt(e.target.value) || 0,
                      })
                    }
                    label={caseUnitLabelPrimaryReturn}
                    percentage={100}
                    disabled={batch.caseToPieceQty === 0}
                  />
                  <CustomCsPcInput
                    value={quantityObj.otherQty}
                    onChange={(e) =>
                      handleReasonQuantityChange(batch.batchId, reasonKey, {
                        ...quantityObj,
                        otherQty: parseInt(e.target.value) || 0,
                      })
                    }
                    label={batch.otherUnitName ?? otherUnitLabelPrimaryReturn}
                    disabled={batch.otherToPieceQty === 0}
                    percentage={100}
                  />
                  <CustomCsPcInput
                    value={quantityObj.pieceQty}
                    onChange={(e) =>
                      handleReasonQuantityChange(batch.batchId, reasonKey, {
                        ...quantityObj,
                        pieceQty: parseInt(e.target.value) || 0,
                      })
                    }
                    label={packUnitLabelPrimaryReturn}
                    percentage={100}
                  />
                  <div
                    style={{ marginTop: "6px", cursor: "pointer" }}
                    onClick={() => onReset(reasonKey)}
                  >
                    <RenderSvg name="undoIcon" />
                  </div>
                </div>
                <span style={{color: "#ff5757", fontSize: "10px"}}>
                  Original Quantity: 
                  <span style={{color: "#d76a6a", fontWeight: "600", fontSize: "11px"}}> 
                    {` ${quantityObj.unsellableCaseQty ?? 0} ${caseUnitLabelPrimaryReturn}, ${quantityObj.unsellableOtherQty ?? 0} ${batch?.otherUnitName ?? otherUnitLabelPrimaryReturn}, ${quantityObj.unsellablePieceQty ?? 0} ${packUnitLabelPrimaryReturn}`} 
                  </span>
                </span>
              </div>
            </div>
          );
        })}
      </div>
               
      <div style={{ display: "flex", justifyContent: "flex-end", gap: "4px", }}>
        
        <button className={`button-remove-batch ${!canRemoveFromReturn ? "button-reset-delivery-disabled" : ""} `}
          style={{
            width: "min-content",
            padding: "2px 12px"
          }}

          onClick={removeBatch} disabled={!canRemoveFromReturn}
        >
          <span style={{whiteSpace: "nowrap"}}>Remove from Return</span>
        </button>
        <button className={`button-save-delivery ${isSaveDisabled ? "button-save-delivery-disabled" : ""}`}
          style={{
            whiteSpace: "nowrap",
            width: "min-content",
            padding: "2px 12px"
          }}
          onClick={onSave} disabled={isSaveDisabled}
        >
          <span className="button-save-delivery-text">{selectedSkuCode ? "Update Return" : "Add to Return"}</span>
        </button>
      </div>
     </div>

  )
};




const PrimaryReturnWithoutGRNEdit: React.FC = () => {

  const navigate = useNavigate();
  const location = useLocation();

  const {selectedSkuCode} = location.state || {};

  //Will pe populated on load and contain data for all skus
  const [skuData, setSkuData] = useState<Record<string, SkuDataForUnsellableReturn>>({});

    // const [editedDetails, setEditedDetails] = useState<withoutGRNBatchDetails[]>([]);
  const [selectedSkuDetails, setSelectedSkuDetails] = useState<SkuDataForUnsellableReturn | null>();

  const [expandedBatch, setExpandedBatch] = useState<withoutGRNBatchDetails | null>(null);

  const [initialBatchDetails, setInitialBatchDetails] = useState<Record<string, withoutGRNBatchDetails[]>>();
  const [batchDetails, setBatchDetails] = useState<Record<string, withoutGRNBatchDetails[]>>();
  const [canRemoveFromReturn, setCanRemoveFromReturn] = useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);
  
  const handleOnClose = () => {
    navigate(-1);
  }

  // Handle fetching skuData
  const fetchData = async () => {
    try {
      setLoader(true);
      const dataFromDB = await getBatchDetailsFromDbPrimaryReturn('primary-return');
      const d = await generateSkuDataForUnsellableReturn();

      if (dataFromDB) {
        setInitialBatchDetails(dataFromDB);
        setBatchDetails(dataFromDB);
        Object.values(d).forEach((sku) => {
          const batchesFromDB = dataFromDB[sku.skuCode] || [];
          sku.batchDetails = sku?.batchDetails?.map((batch) => {
            const batchFromDB = batchesFromDB.find((b) => b.batchId === batch.batchId);
            return {
              ...batch,
              reasonQuantityMap: batchFromDB ? batchFromDB.reasonQuantityMap : batch.reasonQuantityMap,
            };
          }
          );
        });
      }
      console.log("SKU Data for Unsellable Return: ", d);
      setSkuData(d);
    } catch (error) {
      console.error("Error fetching SKU data for Unsellable Return: ", error);
      openPopup(
        "Alert",
        `Something went wrong. Please try again later.`
       );
    } finally {
      setLoader(false);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  const handleChangeExpandedBatch = async (batch: withoutGRNBatchDetails) => {
    setExpandedBatch((prevState: withoutGRNBatchDetails | null) =>
      prevState?.batchId === batch?.batchId ? null : batch
    );
  };

  //It should add this batch id to return
  const handleSave = () => {
    setSkuData((prevSkuData) => {
      if (!selectedSkuDetails) return prevSkuData;
      return {
        ...prevSkuData,
        [selectedSkuDetails.skuCode]: selectedSkuDetails,
      };
    });
    updateReturn(expandedBatch!.batchId);
  }

  const handleReset = (reason: string) => {
    setSelectedSkuDetails((prevSkuDetails) => {
      if (!prevSkuDetails || !expandedBatch) return prevSkuDetails;
      const updatedBatches = prevSkuDetails.batchDetails?.map((batch) => {
        if (batch.batchId === expandedBatch.batchId) {
          const updatedReasonQuantityMap = { ...batch.reasonQuantityMap };
          const initialReasonQuantityMap = batch.initialReasonQuantityMap || {};
          updatedReasonQuantityMap[reason] = initialReasonQuantityMap[reason] || { caseQty: 0, pieceQty: 0, otherQty: 0 };
          return {
            ...batch,
            reasonQuantityMap: updatedReasonQuantityMap,
          };
        }
        return batch;
      });
      return {
        ...prevSkuDetails,
        batchDetails: updatedBatches,
      };
    });
  }

  const handleResetAll = () => {
    setSkuData((prevSkuData) => {
      if (!selectedSkuDetails) return prevSkuData;
      const resetBatches = selectedSkuDetails.batchDetails?.map((batch) => {
        return {
          ...batch,
          reasonQuantityMap: batch.initialReasonQuantityMap ? { ...batch.initialReasonQuantityMap } : {},
        };
      });
      const resetSkuDetails = {
        ...selectedSkuDetails,
        batchDetails: resetBatches,
      };
      setSelectedSkuDetails(resetSkuDetails);
      return {
        ...prevSkuData,
        [selectedSkuDetails.skuCode]: resetSkuDetails,
      };
    });
  }


  const handleSkuSelection = (field: "skuCode" | "skuName", value: string | null) => {
    if(!value){
        setSelectedSkuDetails(null);
        setExpandedBatch(null);
        return;
    }
  

    //if the selected sku is already in initialBatchDetails, the open popup
    //
    const skuCode = field === "skuCode" ? value : Object.keys(skuData).find((code) => skuData[code].skuName === value) || null;

    const isSkuInReturn = initialBatchDetails && Object.keys(initialBatchDetails ?? {}).includes(skuCode || "") && (initialBatchDetails?.[skuCode || ""]?.length ?? 0) > 0;

    if (isSkuInReturn) {
      openPopup(
        "Alert",
        `The selected SKU is already added to the return. Please edit the return to modify the quantities.`
      );
      return;
    }

    let selectedSku: SkuDataForUnsellableReturn | null = null;
    if(field === "skuCode"){
        selectedSku = skuData[value] || null;
    } else {
        selectedSku = Object.values(skuData).find((sku) => sku.skuName === value) || null;
    }
    setSelectedSkuDetails(selectedSku);
    setExpandedBatch(selectedSku?.batchDetails?.[0] ?? null);
  }

  const validateQuantityObj = (batchId: string, reason: string, quantityObj: QuantityObj) => {
    const existingBatchDetails = selectedSkuDetails?.batchDetails?.find((batch) => batch.batchId === batchId);
    if(!existingBatchDetails) return false;

    const normalizedQuantity = quantityObj.caseQty * (selectedSkuDetails?.caseToPieceQty ?? 0) + quantityObj.pieceQty + quantityObj.otherQty * (selectedSkuDetails?.otherToPieceQty ?? 0);

    const initialQuantity = (quantityObj?.unsellableCaseQty ?? 0) * (selectedSkuDetails?.caseToPieceQty ?? 0) + (quantityObj?.unsellablePieceQty ?? 0)+ (quantityObj?.unsellableOtherQty ?? 0) * (selectedSkuDetails?.otherToPieceQty ?? 0);

    if(normalizedQuantity < 0){
        openPopup(
          "Alert",
          `Added Quantity cannot be negative.`
        );
        return false;
    }

    if(normalizedQuantity > initialQuantity){
        openPopup(
          "Alert",
          `The added quantity cannot exceed the original quantity.`
        );
        return false;
    }

    return true;

  }


  const handleReasonQuantityChange = (batchId: string, reason: string, quantityObj: QuantityObj) => {

    if (!validateQuantityObj(batchId, reason, quantityObj)) {
      return;
    }

    if(!selectedSkuDetails) return;
    const updatedBatches = selectedSkuDetails.batchDetails?.map((batch) => {
        if(batch.batchId === batchId){
            const updatedReasonQuantityMap = {
                ...batch.reasonQuantityMap,
                [reason]: quantityObj
            };
            return {
                ...batch,
                reasonQuantityMap: updatedReasonQuantityMap
            }
        }
        return batch;
    });
    setSelectedSkuDetails({
        ...selectedSkuDetails,
        batchDetails: updatedBatches
    });
  }


  useEffect(() => {
    if (expandedBatch) {
      const updatedExpandedBatch = selectedSkuDetails?.batchDetails?.find(
        (batch) => batch.batchId === expandedBatch.batchId
      );
      if (updatedExpandedBatch) {
        setExpandedBatch(updatedExpandedBatch);
      } else {
        setExpandedBatch(null);
      }
    }

  }, [selectedSkuDetails]);

  useEffect(() => {
    if (!expandedBatch || !batchDetails || !selectedSkuDetails) {
      setCanRemoveFromReturn(false);
      return;
    }
    const currentBatchesForSku = batchDetails[selectedSkuDetails.skuCode] || [];
    const isInCurrent = currentBatchesForSku.some((batch) => batch.batchId === expandedBatch.batchId);
    //If present in current then we have to remove, but if not then when we save, it will automatically
    //get removed
    setCanRemoveFromReturn(isInCurrent);
  }, [
    expandedBatch,
    selectedSkuDetails,
    batchDetails,
  ]);

  //Remove the batch details from initialBatchDetails 
  const removeFromReturn = () => {
    setSkuData((prevSkuData) => {
      if (!selectedSkuDetails) return prevSkuData;
      return {
        ...prevSkuData,
        [selectedSkuDetails.skuCode]: selectedSkuDetails,
      };
    });
    setBatchDetails((prevDetails) => {
      if (!selectedSkuDetails) return prevDetails;
      const existingBatches = prevDetails?.[selectedSkuDetails.skuCode] || [];
      const updatedBatches = existingBatches.filter((batch) => batch.batchId !== expandedBatch?.batchId);
      return {
        ...prevDetails,
        [selectedSkuDetails.skuCode]: updatedBatches,
      };
    });
  }

  //Update the batch deatils in the initialBatchDetails, if not present add it
  const updateReturn = (batchId: string) => {
    setBatchDetails((prevDetails) => {
      if (!selectedSkuDetails) return prevDetails;
      const batchToUpdate = selectedSkuDetails.batchDetails?.find((batch) => batch.batchId === batchId);
      if (!batchToUpdate) return prevDetails;
      const existingBatches = prevDetails?.[selectedSkuDetails.skuCode] || [];
      const batchExists = existingBatches.find((batch) => batch.batchId === batchId);
      let updatedBatches;
      if (batchExists) {
        updatedBatches = existingBatches.map((batch) =>
          batch.batchId === batchId ? batchToUpdate : batch
        );
      } else {
        updatedBatches = [...existingBatches, batchToUpdate];
      }
      return {
        ...prevDetails,
        [selectedSkuDetails.skuCode]: updatedBatches,
      };
    });
  }

  const isBatchIDAlreadyInReturn = (batchId: string) => {
    if (!batchDetails || !selectedSkuDetails) return false;
    const existingBatches = batchDetails?.[selectedSkuDetails.skuCode] || [];
    return existingBatches.some((batch) => batch.batchId === batchId);
  }

  const resetSelectedBatch = () => {
    setSkuData((prevSkuData) => {
      if (!selectedSkuDetails) return prevSkuData;
      const resetBatches = selectedSkuDetails.batchDetails?.map((batch) => {
        if (batch.batchId !== expandedBatch?.batchId) return batch;
        return {
          ...batch,
          reasonQuantityMap: batch.initialReasonQuantityMap ? { ...batch.initialReasonQuantityMap } : {},
        };
      });
      const resetSkuDetails = {
        ...selectedSkuDetails,
        batchDetails: resetBatches,
      };
      setSelectedSkuDetails(resetSkuDetails);
      return {
        ...prevSkuData,
        [selectedSkuDetails.skuCode]: resetSkuDetails,
      };
    });
  }

  useEffect(() => {
    //If selectedSkuCode is present in location state, then select that sku on load
    if(selectedSkuCode){
        const selectedSku = skuData[selectedSkuCode];
        if(selectedSku){
            setSelectedSkuDetails(selectedSku);
            if (!expandedBatch) setExpandedBatch(selectedSku.batchDetails?.[0] ?? null)
        }
    }
  }, [skuData, selectedSkuCode]);

  //Persist the initialBatchDetails in DB on submit
  const handleOnSubmit = async () => {
    await setBatchDetailsInDbPrimaryReturn( batchDetails || {}, 'primary-return');
    navigate(-1);
  }

  return (
    <div className="edit-return-container">
      <header style={{height: "min-content", padding: "16px 20px"}}>
        <div>
          <WestIcon style={{ cursor: "pointer" }} onClick={() => navigate(-1)} />
          <p> Create Primary Return - Add Products</p>
        </div>
        <CloseIcon style={{ cursor: "pointer" }} onClick={handleOnClose} />
      </header>
      {
        loader ?
        <Loader />
        :
      <>
        <div className="edit-return-model-container" style={{height: "100%", overflow: "hidden"}}>
          <div className="inside-header" style={{alignItems: "center", gap: "24px"}}>
              <div className="arpm-labelInput-container">
                <p className="arpm-label">
                  SKU Code<span>*</span>
                </p>
                <CustomAutocomplete
                  options={Object.keys(skuData)}
                  getOptionLabel={(option) => option}
                  value={selectedSkuDetails?.skuCode || ""}
                  label="Select SKU Code"
                  onChange={(e: any, value: string | null) => {
                    handleSkuSelection("skuCode", value);
                  }}
                  name="skuCode"
                  height="40px"
                  color="#464646"
                  fontSize="14px"
                  disabled={!!selectedSkuCode}
                />
              </div>
              <div className="arpm-labelInput-container ">
                <p className="arpm-label">
                  SKU Name<span>*</span>
                </p>
                <CustomAutocomplete
                  options={Object.values(skuData).map((sku) => sku.skuName)}
                  getOptionLabel={(option) => option}
                  value={selectedSkuDetails?.skuName || ""}
                  label="Select SKU Name"
                  onChange={(e: any, value: string | null) => {
                    handleSkuSelection("skuName", value);
                  }}
                  name="skuName"
                  height="40px"
                  color="#464646"
                  fontSize="14px"
                  disabled={!!selectedSkuCode}
                />
              </div>
          </div>
          <div className="inside-body" style={{gap: "15px", padding: "15px", paddingBottom: "0px", height: "100%", overflow: "hidden"}}>
              <div className="batch-id-text-delivery" style={{margin:"0px", whiteSpace: "nowrap"}}>
                  Batch ID
              </div>
              <div className="edit-left" style={{width: "100%"}}>
                  <div className="batches-list-container-delivery" style={{height: "100%", overflow: "hidden"}}>
                      <div className="batch-list-heading">
                          <span>Select a batch ID to add damage quantity</span>
                      </div>
                      <div className="batches-list-delivery" style={{scrollbarWidth: "thin"}}>
                        {selectedSkuDetails?.batchDetails?.length ? selectedSkuDetails?.batchDetails?.map((batch) => {
                          return (
                              <PrimaryReturnWithoutGRNBatchItem
                                  key={batch.batchId}
                                  batch={batch}
                                  isSelected={expandedBatch?.batchId === batch.batchId}
                                  onSelect={() => {
                                    handleChangeExpandedBatch(batch)
                                  }
                                  }
                                  isMarked={isBatchIDAlreadyInReturn(batch.batchId)}
                              />
                          );
                        }):
                        <div className="batch-list-heading center">
                            <span>No Batch ID</span>
                        </div>
                        }
                      </div>
                  </div>
              </div>
              {true && (
              <div className="edit-right-delivery" style={{width: "100%", visibility: expandedBatch?.batchId ? "visible" : "hidden"}}>
              <div className="edit-right-delivery-top" style={{height: "100%"}}>
                <div className="edit-right-delivery-top-header">
                  <div style={{display: "flex", gap: "16px", justifyContent: "space-between", alignItems: "center", width: "100%"}}>
                    <p className="batch-id-nos-delivery">{expandedBatch?.batchId}</p>
                    <button className="button-reset-delivery" onClick={resetSelectedBatch} style={{width: "min-content", padding: "2px 12px"}}>
                      <span className="button-reset-delivery-text" style={{whiteSpace: "nowrap"}}>Reset</span>
                    </button>
                  </div>
                </div>
                <div className="batch-ids-container-delivery" style={{paddingBottom: "20px"}}>
                  
                  <div className="reasons-parent-delivery" style={{display: "flex", flexDirection: "column", gap: "10px", padding: "10px", height: "100%"}}>
                    {
                    expandedBatch && selectedSkuDetails?.batchDetails?.length ? (
                      <BatchEditorWithoutGRN
                        savedBatch={skuData[selectedSkuDetails.skuCode].batchDetails!.find((b) => b.batchId === expandedBatch.batchId)!}
                        batch={expandedBatch}
                        onReset={handleReset}
                        onSave={handleSave}
                        handleReasonQuantityChange={handleReasonQuantityChange}
                        removeBatch={removeFromReturn}
                        canRemoveFromReturn={canRemoveFromReturn}
                        batchDetails={batchDetails ? batchDetails[selectedSkuDetails.skuCode] : []}
                        selectedSkuCode={selectedSkuCode}
                      />
                    ) : (
                      ""
                    )
                  }
   
                  </div>
                </div>
              </div>
            </div>
              )}
          </div>
        </div>
        <footer style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", padding: "10px 15px" }}>
          
          <div style={{ display: "flex", gap: "10px"}}>
            {/* <button className="button-reset-delivery" onClick={handleResetAll} style={{width: "100%"}}> */}
            {/*   <span className="button-reset-delivery-text" style={{whiteSpace: "nowrap"}}>Reset Selected SKU</span> */}
            {/* </button> */}
            <button className="button-save-delivery" onClick={handleOnSubmit}>
              <span className="button-save-delivery-text">Submit</span>
            </button>
          </div>
        </footer>
      </>
      }

    </div>
  );
};

export default PrimaryReturnWithoutGRNEdit;
